export const buildExportUrl = (path: string, params: Record<string, unknown>): string => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") {
      return;
    }
    searchParams.set(key, String(value));
  });
  searchParams.set("format", "xlsx");
  const query = searchParams.toString();
  return query ? `${path}?${query}` : `${path}?format=xlsx`;
};
